import type { FC } from 'react';
import type { VersionsTabProps } from './VersionsTab.types';

import { DocumentTimeline, DOCUMENT_TIMELINE_TYPE } from '../../../../../../../DocumentTimeline';

export const VersionsTab: FC<VersionsTabProps> = ({ document }) => {
  return <DocumentTimeline type={DOCUMENT_TIMELINE_TYPE.VERSION} document={document} />;
};
